<template>
  <div class="table-wrapper">
    <div class="table-responsive" :style="styles">
      <table class="pricing-table" ref="root">
        <tbody>
          <template v-for="({ name, items }, index) in featuresList">
            <tr :key="`${name}${index}`">
              <th>{{ name }}</th>
              <th :style="thStyles">Pro+</th>
              <th :style="thStyles">Pro</th>
              <th :style="thStyles">Org Pro+</th>
              <th :style="thStyles">Org Pro</th>
              <th :style="thStyles">Free</th>
            </tr>
            <tr
              v-for="({ name, description, to, href, supported }, i) in items"
              :key="`${name}${i}`"
            >
              <td>
                <PricingTableItem
                  :description="description"
                  :to="to"
                  :href="href"
                >
                  {{ name }}
                </PricingTableItem>
              </td>
              <td v-for="i in 5" :key="i">
                <PricingTableIcon
                  :supported="supported"
                  :index="i - 1"
                  variant="default"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@nuxtjs/composition-api';
import { useTheme } from '@campsite-bio/component-lib';
import tinycolor from 'tinycolor2';
import { useMediaQuery } from '@vueuse/core';

import PricingTableItem from './pricing-table-item';
import PricingTableIcon from './pricing-table-icon';
import featuresList from './features-list.json';

export default {
  components: {
    PricingTableIcon,
    PricingTableItem,
  },

  setup() {
    const theme = useTheme();
    const root = ref(null);

    const styles = computed(() => {
      return {
        '--c-pro-color': tinycolor(theme.value.colors.primary)
          .setAlpha(0.1)
          .toRgbString(),
      };
    });

    const isLargerScreen = useMediaQuery('(min-width: 768px)');
    const thStyles = computed(() => {
      return {
        width: isLargerScreen.value ? '150px' : '130px',
      };
    });

    return {
      root,
      featuresList,
      styles,
      thStyles,
    };
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin-left: -1rem;
  margin-right: -1rem;

  @media (min-width: 768px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

.pricing-table {
  border-spacing: 0;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  thead th,
  tbody th {
    border-bottom: 3px solid var(--g-color-gray-200);
    font-weight: 900;
    font-size: 0.85rem;
    padding: 1rem;

    @media (min-width: 768px) {
      font-size: 1rem;
    }

    &:first-child {
      text-align: left;
    }

    &:nth-child(3),
    &:nth-child(5) {
      border-bottom-color: var(--g-color-secondary);
    }
  }

  tbody {
    td,
    th {
      border-bottom: 1px solid var(--g-color-gray-200);
      padding: 0.5rem 0.75rem;

      @media (min-width: 544px) {
        padding: 0.75rem 1rem;
      }

      &:first-child {
        text-align: left;
      }
    }

    td {
      font-size: 0.8rem;

      &:nth-child(2),
      &:last-child {
        background: rgba(#222, 0.01);
      }

      &:nth-child(3),
      &:nth-child(5) {
        background: var(--c-pro-color);
      }
    }

    th {
      background: none;
      padding-top: 2rem;

      @media (min-width: 768px) {
        padding-top: 3rem;
      }
    }
  }
}
</style>
